"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromLayoutId = exports.toLayoutId = void 0;
var layoutMap = {
    apartment: 1,
    duplex: 2,
    triplex: 3,
    penthouse: 4,
    house: 5,
    studio: 7,
    'detached-house': 16,
    'village-house': 17,
};
exports.toLayoutId = function (key) {
    return layoutMap[key];
};
exports.fromLayoutId = function (id) {
    return Object.entries(layoutMap).find(function (_a) {
        var k = _a[0], v = _a[1];
        return v === id;
    })[0];
};
